import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

export default function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    setError('');
    try {
      const form = new FormData();
      form.append('username', username);
      form.append('password', password);
      const res = await axios.post('/api/auth/login', form);
      localStorage.setItem('token', res.data.access_token);
      navigate('/dashboard');
    } catch {
      setError(t('login.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 rounded-xl p-8 w-full max-w-sm shadow-xl">
        <h1 className="text-2xl font-bold text-white mb-6 text-center">⚡ {t('login.title')}</h1>
        {error && <div className="bg-red-900 text-red-200 rounded px-4 py-2 mb-4 text-sm">{error}</div>}
        <div className="space-y-4">
          <div>
            <label className="text-gray-400 text-sm block mb-1">{t('login.username')}</label>
            <input
              className="w-full bg-gray-700 text-white rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={username}
              onChange={e => setUsername(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
            />
          </div>
          <div>
            <label className="text-gray-400 text-sm block mb-1">{t('login.password')}</label>
            <input
              type="password"
              className="w-full bg-gray-700 text-white rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
            />
          </div>
          <button
            onClick={submit}
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded py-2 font-medium transition-colors disabled:opacity-50"
          >
            {loading ? t('common.loading') : t('login.submit')}
          </button>
        </div>
      </div>
    </div>
  );
}
